import { Injectable } from '@angular/core';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { IFLDocuments } from '../../documents-cercador/documents.interfaces';

@Injectable()
export class DocumentsService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public activeFilters: any = {};
  public valFiltres = {};
  public currentPage: number = 0;
  public rowsPerPage: number = 20;

  public getSearchValues(id) { return (this.valFiltres[id]?this.valFiltres[id]:""); }

  
  public getActive(limit = 10, skip = 0, filters = {}, conds = {}, ordering = {}): Observable<any> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('skip', skip.toString());
    
    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString()));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    return this.authHttp.get(APIURLConstantsService._API_BASE_URL + 'documents', this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => {
      return response || [];
    }));
  }

   public createDocument(data) {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'documents', data)
      .pipe(map(response => response || {}));
  }

  public updateDocument(idDoc, data) {
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + 'documents/'+idDoc, data)
      .pipe(map(response => response || {}));
  }

  public deleteDocument(idDoc) {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + 'documents/'+idDoc)
      .pipe(map(response => response || {}));
  }

  constructor(protected authHttp: HttpClient) {}

}

